export default function Django_Display_Data() {
  return <div>Django_Display_Data Component</div>;
}
